import React from 'react';

const ChatGPTLaunch = () => (
  <article className="news-article-body">
    <p className="news-lead">
      On November 30, 2022, OpenAI quietly put a chatbot on the internet and called it a
      "low-key research preview." Within hours, servers in Japan crashed under the load.
      Within two months, 100 million people had tried it. Within two years, it had 300 million
      weekly users and $4 billion in annual revenue. No tech product had ever grown that fast.
    </p>

    <h2>So what exactly was ChatGPT?</h2>
    <p>
      ChatGPT is built on GPT-3.5 - an improved version of GPT-3 that finished training in
      early 2022. The real trick wasn't the raw model though. It was how OpenAI trained it to
      have a conversation.
    </p>
    <p>
      They used a technique called <strong>Reinforcement Learning from Human Feedback (RLHF)</strong>.
      Basically, human trainers rated the model's responses and played both sides of a
      conversation - acting as both the user and the AI assistant. That feedback shaped ChatGPT
      into something that actually feels helpful to talk to, rather than just predicting the
      next word.
    </p>

    <h2>Why did it hit so differently?</h2>
    <p>
      GPT-3 had been available since 2020. So why did ChatGPT go viral when GPT-3 didn't?
      A few reasons:
    </p>
    <ul>
      <li><strong>Zero friction.</strong> Free, in your browser, no setup. Anyone with an email address could try it in two minutes.</li>
      <li><strong>Conversation feels natural.</strong> Humans already know how to have a chat. You don't need to learn a prompt language or API.</li>
      <li><strong>It did everything.</strong> Write code, explain concepts, draft emails, make up poems, summarise documents - all in one tool.</li>
      <li><strong>Perfect timing.</strong> Remote work was mainstream. Knowledge workers were already looking for AI productivity tools.</li>
    </ul>

    <h2>The NeurIPS moment</h2>
    <p>
      ChatGPT launched right in the middle of NeurIPS 2022 - the world's biggest AI research
      conference. Academic researchers who'd spent years building specialist benchmark-crushing
      systems suddenly found themselves outflanked by a product decision: make it easy to use.
      ChatGPT was all anyone talked about that week.
    </p>

    <h2>What happened to the rest of the industry</h2>
    <p>
      Google issued an internal "code red." Microsoft invested $10 billion in OpenAI and
      plugged ChatGPT into Bing and Office 365. Meta released LLaMA weights. Anthropic
      launched Claude. Every major tech company reshuffled priorities. The modern AI arms
      race started the night of November 30, 2022.
    </p>

    <h2>From research preview to $4B platform</h2>
    <p>
      Within two years, ChatGPT had grown into a full platform - custom GPTs, an API powering
      thousands of apps, voice mode, image generation (DALL-E 3), data analysis tools, and
      deep integrations into enterprise software. What started as a research demo became
      a $4 billion revenue engine with no signs of slowing down.
    </p>

    <div className="news-insight-box">
      <h3>The big lesson</h3>
      <p>
        ChatGPT's success had very little to do with a technical breakthrough - GPT-3 already
        existed. It was about product design. Make it accessible, make it conversational, make
        it free. Every major AI development since November 2022 traces its urgency back to
        that one launch.
      </p>
    </div>
  </article>
);

export default ChatGPTLaunch;
